export default __webpack_public_path__ + "static/media/EAST1030.34I-34162_-18409_0.afb37a3f.jpg";